// This class contains the necessary method of gathering plan data for the Summary Of Coverage form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class SummaryOfCoverageForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [...this.getFuneralHomeRepresentativeMappings()]
	}
}
